import React, { createContext, useState, useContext, ReactNode } from 'react';

interface PageHighlightContextType {
  highlightColor: string;
  setHighlightColor: (color: string) => void;
}

const defaultContextValue: PageHighlightContextType = {
  highlightColor: '',
  setHighlightColor: () => {},
};

export const PageHighlightContext = createContext<PageHighlightContextType>(defaultContextValue);

export const usePageHighlight = () => {
  const context = useContext(PageHighlightContext);
  return context || defaultContextValue;
}

interface PageHighlightProviderProps {
  children: ReactNode;
}

export const PageHighlightProvider: React.FC<PageHighlightProviderProps> = ({ children }) => {
  const [highlightColor, setHighlightColor] = useState<string>(defaultContextValue.highlightColor);

  return (
    <PageHighlightContext.Provider value={{ highlightColor, setHighlightColor }}>
      {children}
    </PageHighlightContext.Provider>
  );
};